import { useEffect } from 'react';
import styles from './error.module.scss';
import Enllac from 'components/corporatiu/Enllac';

export default function Error() {
    useEffect(() => {
        window._qual_async = window._qual_async || [];

        const initQualifio = () => {
            window._qual_async.push(['setIframeAttributes', { title: 'Prova 2 Actius Digitals La Botiga' }]);
            window._qual_async.push([
                'createIframe',
                'qualifio_insert_place_1785325',
                'ptcpns.ccma.cat',
                '20',
                '01555161-BDB5-4FC2-A102-3AFC43BC87AB',
                '100%',
                '1200',
                '',
                '',
                '',
                'max-width:1014px;margin:0 auto;'
            ]);
        };

        const existingScript = document.querySelector('script[src="https://files.qualifio.com/kit/qualp.2.min.js"]');

        if (existingScript) {
            initQualifio();
            return;
        }

        const script = document.createElement('script');
        script.src = 'https://files.qualifio.com/kit/qualp.2.min.js';
        script.async = true;
        script.onload = initQualifio;
        document.body.appendChild(script);

        return () => {
            script.onload = null;
        };
    }, []);

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.innerWrapper}>
                    <div className={styles.textWrapper}>
                        <img
                            src='https://statics.3cat.cat/recursos/corporatiu/botiga/logo_botiga.png'
                            alt='Avís botiga'
                            className={styles.logo}
                        />
                        {/* <h1>Ben aviat trobaràs la nova botiga de 3Cat.</h1>
                    <p>Hem estat treballant en una experiència integral que en breu podrem compartir amb tu.</p>
                    <p>
                        Mentrestant, escriu-nos si tens qualsevol dubte o si vols que t&apos;avisem quan la botiga torni a estar
                        disponible.
                    </p>
                    <Boto text='Contacta amb nosaltres' />
                    <p>Recorda't que tots els productes 3Cat també els pots trobar als punts de venda habituals.</p> */}
                        <div id='qualifio_insert_place_1785325' className='qualifio_iframe_wrapper'></div>
                    </div>
                </div>
            </div>
            <div className={styles.dades}>
                <div className={styles.innerWrapper}>
                    Informació en matèria de protecció de dades: D&apos;acord amb el que estableix que estableix la normativa
                    vigent en matèria de protecció de dades personals, t&apos;informem que de facilitar-nos el teu correu, aquest
                    serà tractat per la Corporació Catalana de Mitjans Audiovisuals SA &#40;pots consultar les seves dades{' '}
                    <Enllac href='https://www.3cat.cat/avis-legal/'>aquí</Enllac> i contactar amb el seu delegat de protecció de
                    dades <Enllac href='https://www.3cat.cat/avis-legal/privacitat/delegat-de-proteccio-de-dades/'>aquí</Enllac>
                    &#41; amb la finalitat de poder informar-te quan estigui oberta la nova botiga de 3Cat així com per
                    informar-te de qualsevol novetat en relació a la mateixa o els productes i activitats de 3Cat per correu
                    electrònic. La base legal per al tractament del teu correu electrònic és el teu consentiment, que podràs
                    retirar en qualsevol moment així com a través del botó per donar-se de baixa que trobaràs en qualsevol de les
                    nostres comunicacions. Les teves dades no seran cedits a tercers, excepte obligació legal, i es conservaran de
                    forma indefinida fins que ens retiris el teu consentiment o exerceixis el teu dret de supressió. Pots exercir
                    els teus drets d&apos;accés, rectificació, supressió, oposició, limitació del tractament i portabilitat
                    enviant una sol·licitud a <Enllac href='mailto:protecciodedades@3cat.cat'>protecciodedades@3cat.cat</Enllac>
                </div>
            </div>
        </>
    );
}
